import * as client from "../ClientConsumer";
import { ShortUrlInfoType } from "./ShortUrl.types";
import { WRAPPER_ACTIONS_ENUM } from "../../Presentation/Shared/Types/GroupEntry.types";

const urlShortenerRoutes = {
    SHORTEN: "/url/shorten",
};

export function shortenUrl(
    communityId: string,
    postId: string,
    action = WRAPPER_ACTIONS_ENUM.OPEN_POST_DETAILS,
): Promise<ShortUrlInfoType> {
    return client
        .postData(urlShortenerRoutes.SHORTEN, {
            communityId: communityId,
            postId: postId,
            action: action,
        })
        .then((res) => res.data);
}
